import {Component, OnInit, Input, OnDestroy, DoCheck} from '@angular/core';
import {GetService} from '../get.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'overage-notification',
    templateUrl: './overage-notification.component.html',
    styleUrls: ['./overage-notification.component.less']
})
export class OverageNotificationComponent implements OnInit {
    @Input()
    set options(opt: any) {
        if (opt) {
            this.attachChanges(opt);
        }
    }

    public message: string = '';
    public title: string = '';

    public translation = {};

    constructor(private getService: GetService,
                public translateService: TranslateService) {
        this.getTranslation()
    }

    attachChanges(options: any): void {
        this.title = options.overage_notification.title;
        this.message = options.overage_notification.message;
    }

    ngOnInit() {
        $('body').addClass('modal-open');
    }

    disableNotification() {
        this.getService.disableOverageNotification();
    }

    getTranslation() {
        this.translateService.get('TUTORIAL.step1_title').subscribe((word: string) => {
            this.translation['step1_title'] = word;
        });
        this.translateService.get('TUTORIAL.step1_description').subscribe((word: string) => {
            this.translation['step1_description'] = word;
        });
        this.translateService.get('TUTORIAL.step2_title').subscribe((word: string) => {
            this.translation['step2_title'] = word;
        });
        this.translateService.get('TUTORIAL.step2_description').subscribe((word: string) => {
            this.translation['step2_description'] = word;
        });
        this.translateService.get('TUTORIAL.step3_title').subscribe((word: string) => {
            this.translation['step3_title'] = word;
        });
        this.translateService.get('TUTORIAL.step3_description').subscribe((word: string) => {
            this.translation['step3_description'] = word;
        });
        this.translateService.get('TUTORIAL.step4_title').subscribe((word: string) => {
            this.translation['step4_title'] = word;
        });
        this.translateService.get('TUTORIAL.step4_description').subscribe((word: string) => {
            this.translation['step4_description'] = word;
        });
        this.translateService.get('TUTORIAL.step5_title').subscribe((word: string) => {
            this.translation['step5_title'] = word;
        });
        this.translateService.get('TUTORIAL.step5_description').subscribe((word: string) => {
            this.translation['step5_description'] = word;
        });
    }

    ngOnDestroy() {
        $('body').removeClass('modal-open');
    }

}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/overage-notification/overage-notification.component.ts